var map = {
	"./@TEMPLATE/Settings": [
		36393,
		6393
	],
	"./BLUESKY_001/Settings": [
		83932,
		4185,
		8908,
		2432,
		8655,
		6853,
		4234
	],
	"./CATALOGUE_001/Settings": [
		78020,
		4185,
		8908,
		2432,
		8655,
		6853,
		1770
	],
	"./COVER_001/Settings": [
		97746,
		4185,
		8908,
		2432,
		8655,
		6593,
		7746
	],
	"./DOCS_PREVIEW_001/Settings": [
		67161,
		4185,
		8908,
		2432,
		8655,
		4275,
		4081
	],
	"./Filter_001/Settings": [
		72883,
		4185,
		8908,
		2432,
		8655,
		6593,
		4275,
		2883
	],
	"./MENU_001/Settings": [
		3580,
		4185,
		8908,
		2432,
		3577,
		5212
	],
	"./SHOPPING_CALL_001_Block/Settings": [
		97890,
		4185,
		8908,
		2432,
		8655,
		9471
	],
	"./SPACER_001/Settings": [
		9557,
		4185,
		8908,
		2432,
		8655,
		6593,
		9557
	],
	"./Search_001/Settings": [
		74417,
		4185,
		8908,
		2432,
		8655,
		6593,
		4417
	],
	"./TEXT_AND_IMAGE_001/Settings": [
		91612,
		3577,
		1612
	],
	"./TEXT_AND_IMAGE_002/Settings": [
		54015,
		6853,
		466
	],
	"./TWITTER_001/Settings": [
		57278,
		4185,
		8908,
		2432,
		8655,
		6593,
		7278
	],
	"./Table_001/Settings": [
		13243,
		4185,
		8908,
		2432,
		8655,
		6853,
		5177
	],
	"./YOUTUBE_001/Settings": [
		19952,
		4185,
		8908,
		2432,
		8655,
		6593,
		9952
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 90662;
module.exports = webpackAsyncContext;